/* eslint-disable angular/window-service */
/* eslint-disable angular/document-service */
import {formatQualificationDateToPqe} from '../../shared/services/format-pqe'
;(function module() {
  angular
    .module('app.ui.form.ctrls')
    .controller('ApplicationListingController', [
      'logger',
      'ApplicationsApi',
      'SharedApi',
      'ApplicationStagesApi',
      '$scope',
      '$rootScope',
      '$window',
      '$log',
      '$uibModal',
      '$sce',
      'usSpinnerService',
      '$location',
      'userService',
      'CandidateProfileApi',
      'socket',
      'NotesApi',
      '$timeout',
      function controller(
        logger,
        ApplicationsApi,
        SharedApi,
        ApplicationStagesApi,
        $scope,
        $rootScope,
        $window,
        $log,
        $uibModal,
        $sce,
        usSpinnerService,
        $location,
        userService,
        CandidateProfileApi,
        socket,
        NotesApi,
        $timeout
      ) {
        let vm = this

        socket.on('APPLICATION_CREATE', async applicationId => {
          $timeout(async () => {
            if ($location.url().contains('application-listing')) {
              const {
                data: newApplication,
              } = await ApplicationsApi.getApplicationListing({
                id: applicationId,
              })

              const formatApplication = setApplicationsListingData(
                newApplication
              )

              vm.applicationListing = [
                ...vm.applicationListing,
                ...newApplication,
              ]
              vm.gridOptions.api.updateRowData({
                addIndex: vm.applicationListing.length,
                add: formatApplication,
              })
              updateGridGroupPipeline()
            }
          }, 1000)
        })
        socket.on('APPLICATION_UPDATE', async applicationId => {
          $timeout(async () => {
            if ($location.url().contains('application-listing')) {
              const {
                data: updatedApplication,
              } = await ApplicationsApi.getApplicationListing({
                id: applicationId,
              })

              if (updatedApplication && updatedApplication.length > 0) {
                const formatApplication = setApplicationsListingData(
                  updatedApplication
                )

                const updateApplicationIndex = vm.applicationListing.findIndex(
                  ({id}) => id === applicationId
                )
                vm.applicationListing[updateApplicationIndex] =
                  formatApplication[0]
                vm.gridOptions.api.updateRowData({update: formatApplication})
              } else {
                const deletedApplication = vm.applicationListing.filter(
                  ({id}) => id === applicationId
                )
                vm.applicationListing = vm.applicationListing.filter(
                  ({id}) => id !== applicationId
                )

                vm.gridOptions.api.updateRowData({remove: deletedApplication})
                $rootScope.$broadcast('application-deleted', {
                  applicationDeleted: applicationId,
                })
              }

              updateGridGroupPipeline()
            }
          }, 1000)
        })

        socket.on('APPLICATION_DELETE', async applicationId => {
          $timeout(async () => {
            if ($location.url().contains('application-listing')) {
              vm.deletedApplicationId = applicationId

              const deletedApplication = vm.applicationListing.filter(
                ({id}) => id === applicationId
              )

              vm.gridOptions.api.updateRowData({remove: deletedApplication})

              updateGridGroupPipeline()
            }
          }, 1000)
        })

        socket.on('CANDIDATE_PROFILE_UPDATE', async candidateId => {
          $timeout(async () => {
            if (
              vm.applicationListing.some(
                application => application.candidateId === candidateId
              ) &&
              $location.url().contains('application-listing')
            ) {
              const {
                data: updatedApplications,
              } = await ApplicationsApi.getApplicationListing({
                candidateId: candidateId,
              })

              if (updatedApplications && updatedApplications.length > 0) {
                if (
                  !vm.schoolList.some(
                    ({id}) => id === updatedApplications[0].candidate.school
                  )
                ) {
                  const {data: schoolList} = await SharedApi.getAllSchools()
                  vm.schoolList = schoolList
                }

                const formatApplications = setApplicationsListingData(
                  updatedApplications
                )

                formatApplications.forEach(application => {
                  const index = vm.applicationListing.findIndex(
                    ({id}) => id === application.id
                  )
                  vm.applicationListing[index] = application
                })

                vm.gridOptions.api.updateRowData({update: formatApplications})
                updateGridGroupPipeline()
              }
            }
          }, 1000)
        })

        socket.on('EMPLOYER_UPDATE', async employerId => {
          $timeout(async () => {
            if (
              vm.applicationListing.some(
                application => application.employerId === employerId
              ) &&
              $location.url().contains('application-listing')
            ) {
              const {
                data: updatedApplications,
              } = await ApplicationsApi.getApplicationListing({
                employerId: employerId,
              })

              if (updatedApplications && updatedApplications.length > 0) {
                const formatApplications = setApplicationsListingData(
                  updatedApplications
                )

                formatApplications.forEach(application => {
                  const index = vm.applicationListing.findIndex(
                    ({id}) => id === application.id
                  )
                  vm.applicationListing[index] = application
                })

                vm.gridOptions.api.updateRowData({update: formatApplications})
                updateGridGroupPipeline()
              }
            }
          }, 1000)
        })

        const dateFilterParameters = {
          suppressAndOrCondition: true,
          inRangeInclusive: true,
          comparator: function(filterLocalDateAtMidnight, cellValue) {
            const dateAsString = moment(cellValue).format('DD/MM/YYYY')
            const dateParts = dateAsString.split('/')
            const cellDate = new Date(
              Number(dateParts[2]),
              Number(dateParts[1]) - 1,
              Number(dateParts[0])
            )

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0
            }

            if (cellDate < filterLocalDateAtMidnight) {
              return -1
            }

            if (cellDate > filterLocalDateAtMidnight) {
              return 1
            }
          },
        }

        // eslint-disable-next-line unicorn/consistent-function-scoping
        function renderDateColumn(parameters) {
          return parameters.value
            ? `<span>` +
                moment(parameters.value).format('DD-MMM-YYYY') +
                `</span>`
            : ' '
        }

        // eslint-disable-next-line unicorn/consistent-function-scoping
        function renderDateTimeColumn(parameters) {
          return parameters.value
            ? `<span>` +
                moment(parameters.value).format('DD-MMM-YYYY HH:mm') +
                `</span>`
            : ' '
        }

        const applicationStatusEnum = {
          ACCEPTED: 'Accepted',
          ACTIVE: 'Active',
          WITHDRAWN: 'Candidate Withdrew',
          DECLINED: 'Employer Declined',
          REJECTED: 'Rejected by LexStep',
        }

        vm.applicationStatusList = [
          {
            id: 1,
            name: applicationStatusEnum.ACTIVE,
            color: '#FFFF00',
          },
          {
            id: 2,
            name: applicationStatusEnum.REJECTED,
            color: '#ffa500',
          },
          {
            id: 3,
            name: applicationStatusEnum.DECLINED,
            color: '#ff0000',
          },
          {
            id: 4,
            name: applicationStatusEnum.WITHDRAWN,
            color: '#ff0000',
          },
          {
            id: 5,
            name: applicationStatusEnum.ACCEPTED,
            color: '#008000',
          },
        ]
        Object.freeze(vm.applicationStatusList)

        const columnDefs = [
          {
            columnGroupShow: undefined,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            width: 134,
            filter: false,
            resizable: false,
          },
          {
            headerName: 'Candidate Details',
            children: [
              {
                headerName: 'Current Candidate Agent',
                field: 'candidateAgentEmail',
              },
              {
                headerName: 'Candidate ID',
                field: 'candidate.id',
                filter: 'agTextColumnFilter',
                columnGroupShow: undefined,
              },
            ],
          },
          {
            headerName: 'Candidate Profile',
            children: [
              {
                headerName: 'Candidate Name',
                field: 'candidateFullName',
                columnGroupShow: undefined,
                onCellClicked: openCandidateProfileModal,
                cellRenderer: function(parameter) {
                  return parameter.value
                    ? `<span class="text-info pointer"/>${parameter.value}</span>`
                    : ``
                },
                filter: 'agTextColumnFilter',
              },
              {
                headerName: 'Qualification Date',
                field: 'candidate.qualificationDate',
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
              {headerName: 'PQE', field: 'candidate.pqe'},
              {headerName: 'Current Location', field: 'candidate.location'},
              {headerName: 'Languages', field: 'candidate.languages'},
              {
                headerName: 'Jurisdiction(s) of Qualification',
                field: 'candidate.jurisdictions',
              },
              {headerName: 'University', field: 'candidate.school'},
              {headerName: 'Nationality', field: 'candidate.nationality'},
            ],
          },
          {
            headerName: 'Candidate Experience',
            children: [
              {
                headerName: 'Current Employer',
                field: 'currentExperience.employer.name',
                columnGroupShow: undefined,
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Employer Type',
                field: 'currentExperience.employerType',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Employer Selectivity',
                field: 'currentExperience.employer.selectivity',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Job Title',
                field: 'currentExperience.jobTitle',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Practice Areas',
                field: 'currentExperience.specialties',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Occupation',
                field: 'currentExperience.occupation',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Contract',
                field: 'currentExperience.contractType',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Salary Currency',
                field: 'currentExperience.salary.salaryUnit',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Salary Amount',
                field: 'currentExperience.salary.salaryAmount',
                filter: 'agNumberColumnFilter',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Salary Period',
                field: 'currentExperience.salary.salaryPeriod',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Bonus Currency',
                field: 'currentExperience.salary.bonusUnit',
                hide: true,
                suppressSizeToFit: true,
              },
              {
                headerName: 'Current Bonus Amount',
                field: 'currentExperience.salary.bonusAmount',
                filter: 'agNumberColumnFilter',
                hide: true,
                suppressSizeToFit: true,
              },
            ],
          },
          {
            headerName: 'Target Employer Details',
            children: [
              {
                headerName: 'Employer',
                field: 'employer.name',
                columnGroupShow: undefined,
              },
              {
                headerName: 'Employer Selectivity',
                field: 'employer.selectivity',
              },
              {headerName: 'Employer Type', field: 'employer.type'},
              {
                headerName: 'Current Employer Agent',
                field: 'employerAgentEmail',
              },
            ],
          },
          {
            headerName: 'Position Details',
            children: [
              {
                headerName: 'Position Title',
                field: 'position.title',
                cellRenderer: function(parameter) {
                  return parameter.value
                    ? `<span class="text-info pointer"/>${parameter.value}</span>`
                    : ``
                },
                columnGroupShow: undefined,
                onCellClicked: openPositionDetailModal,
                filter: 'agTextColumnFilter',
              },
              {headerName: 'Req. PQE', field: 'position.rPQE', width: 125},
              {headerName: 'Location', field: 'position.locations'},
              {headerName: 'Practice Areas', field: 'position.specialties'},
              {headerName: 'Contract', field: 'position.contractType'},
              {headerName: 'Occupation', field: 'position.occupation'},
              {
                headerName: 'Regular ATS Link',
                field: 'position.externalUrl',
                filter: false,
                cellRenderer: function(parameter) {
                  const positionUrl = parameter.value
                    ? parameter.value.match(/http/)
                      ? parameter.value
                      : 'http://'.concat(parameter.value)
                    : parameter.value
                  return parameter.value
                    ? `<span class="text-info pointer"/><a style="color:#4c9bda" href=${positionUrl} target="_blank"/>${parameter.value}</span>`
                    : ``
                },
              },
            ],
          },
          {
            headerName: 'Listing Details',
            children: [
              {
                headerName: 'LexStep Position ID',
                field: 'position.id',
                filter: 'agTextColumnFilter',
              },
              {headerName: '# Applicants', field: 'position.applicantCount'},
              {
                headerName: 'Listing Type',
                field: 'position.type',
                columnGroupShow: undefined,
              },
              {headerName: 'Position Visibility', field: 'position.visible'},
              {
                headerName: 'Uploaded',
                field: 'position.created',
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Expired',
                field: 'position.expiresAt',
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
            ],
          },
          {
            headerName: 'Application Details',
            children: [
              {
                headerName: 'Application ID',
                field: 'id',
                columnGroupShow: undefined,
                filter: 'agTextColumnFilter',
              },
              {
                headerName: 'Internal Note',
                field: 'note',
                onCellClicked: openHistoryModal,
                columnGroupShow: undefined,
                filter: 'agTextColumnFilter',
                cellClass: 'cellEditable',
              },
              {
                headerName: 'Application Date',
                field: 'created',
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Submission Date',
                field: 'submittedAt',
                onCellDoubleClicked: openDateModal,
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
                cellClass: 'cellEditable',
              },
              {
                headerName: '1st Interview Date',
                field: 'interview1Date',
                onCellDoubleClicked: openDateModal,
                cellRenderer: renderDateTimeColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
                cellClass: 'cellEditable',
              },
              {
                headerName: '2nd Interview Date',
                field: 'interview2Date',
                onCellDoubleClicked: openDateModal,
                cellRenderer: renderDateTimeColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
                cellClass: 'cellEditable',
              },
              {
                headerName: '3rd Interview Date',
                field: 'interview3Date',
                onCellDoubleClicked: openDateModal,
                cellRenderer: renderDateTimeColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
                cellClass: 'cellEditable',
              },
              {
                headerName: 'Offer {£ Value}',
                field: 'offer',
                editable: true,
                onCellValueChanged: onApplicationChange,
                filter: 'agTextColumnFilter',
                cellClass: 'cellEditable',
              },
              {
                headerName: 'Acceptance Date',
                field: 'acceptedAt',
                onCellDoubleClicked: openDateModal,
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
                cellClass: 'cellEditable',
              },
              {
                headerName: 'Start Date',
                field: 'startDate',
                onCellDoubleClicked: openDateModal,
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
                cellClass: 'cellEditable',
              },
              {
                headerName: 'Sponsorship required?',
                field: 'sponsorship',
              },
              {
                headerName: 'CV',
                field: 'cvUrl',
                onCellClicked: cvCellClicked,
                filter: false,
                columnGroupShow: undefined,
                cellRenderer: function(parameter) {
                  if (parameter.value)
                    return `<center class=""><img class="" style="width: 28px" src="/images/resume.png" /></center>`
                  if (parameter.value !== null)
                    return `<center class=""><img class=" disabled-icon" style="width: 28px" src="/images/resume.png" /></center>`
                },
                width: 100,
              },
              {
                headerName: 'Stage',
                field: 'parentApplicationStage',
                rowGroupIndex: 0,
                columnGroupShow: undefined,
              },
              {
                headerName: 'Sub-Stage',
                field: 'applicationStage',
                rowGroupIndex: 1,
                editable: true,
                columnGroupShow: undefined,
                cellRenderer: 'subStageCellRenderer',
                cellEditor: 'agRichSelectCellEditor',
                onCellValueChanged: onApplicationChange,
                cellEditorParams: {
                  values: [],
                  cellRenderer: 'subStageCellRenderer',
                },
                cellClass: 'cellEditable',
              },
              {
                headerName: 'Last Stage Change',
                field: 'lastStageChangeAt',
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Status',
                field: 'status',
                rowGroupIndex: 2,
                editable: true,
                columnGroupShow: undefined,
                cellRenderer: 'statusCellRenderer',
                cellEditor: 'agRichSelectCellEditor',
                onCellValueChanged: onApplicationChange,
                cellEditorParams: {
                  values: vm.applicationStatusList.map(status => status.name),
                  cellRenderer: 'statusCellRenderer',
                },
                cellClass: 'cellEditable',
              },
              {
                headerName: 'Admin Followers',
                field: 'applicationAgentEmail',
                onCellDoubleClicked: openAgentFollowersModal,
                cellClass: 'cellEditable',
              },
              {
                headerName: 'Feedback To Candidate',
                field: 'feedback',
                editable: true,
                filter: 'agTextColumnFilter',
                cellEditor: 'agLargeTextCellEditor',
                onCellValueChanged: onApplicationChange,
                cellClass: 'cellEditable',
              },
              {
                headerName: 'Source',
                field: 'isOffPlatform',
                columnGroupShow: undefined,
                width: 120,
              },
              {
                headerName: 'Application Candidate Agent',
                field: 'applicationCandidateAgentEmail',
              },
              {
                headerName: 'Application Employer Agent',
                field: 'applicationEmployerAgentEmail',
              },
              {
                headerName: 'Application History',
                field: 'history',
                filter: false,
                cellRenderer: function() {
                  return `<center><span class="fa fa-history"/></center>`
                },
                onCellClicked: openHistoryModal,
              },
            ],
          },
        ]

        const gridOptions = {
          defaultColDef: {
            sortable: true,
            filter: true,
            enablePivot: true,
            enableRowGroup: true,
            enableValue: true,
            columnGroupShow: 'open',
            resizable: true,
            menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
          },
          postProcessPopup: function(parameters) {
            // Check callback is for menu
            if (parameters.type !== 'columnMenu') {
              return
            }

            const columnId = parameters.column.getId()
            if (
              columnId === 'position.specialties' ||
              columnId === 'currentExperience.specialties'
            ) {
              parameters.ePopup.style.width = '350px'
            }
          },
          onFilterChanged: onFilterChanged,
          onGridReady: function() {
            initializeApplicationListing()
          },
          groupRowRenderer: 'agGroupCellRenderer',
          groupRowRendererParams: {
            checkbox: true,
          },
          getRowStyle: function(parameters) {
            if (
              !parameters.data &&
              parameters.node.field === 'applicationStage'
            ) {
              return {
                background: hexToRGB(
                  vm.applicationSubStagesList.find(row => {
                    return row.name === parameters.node.key
                  }).color,
                  0.2
                ),
              }
            }
          },
          floatingFilter: true,
          suppressCsvExport: true,
          groupDefaultExpanded: -1,
          groupUseEntireRow: true,
          defaultGroupSortComparator: function(nodeA, nodeB) {
            if (
              nodeA.field !== 'applicationStage' &&
              nodeB.field !== 'parentApplicationStage'
            ) {
              if (nodeA.key < nodeB.key) {
                return -1
              }

              if (nodeA.key > nodeB.key) {
                return 1
              }

              return 0
            }
          },
          columnDefs: columnDefs,
          animateRows: true,
          getRowNodeId: function(data) {
            return data.id
          },
          enableCellChangeFlash: true,
          groupSelectsChildren: true,
          rowData: vm.applicationListing,
          rowSelection: 'multiple',
          rowGroupPanelShow: 'always',
          pivotPanelShow: 'always',
          groupSelectsFiltered: true,
          sideBar: {
            toolPanels: ['columns', 'filters'],
            defaultToolPanel: false,
          },
          statusBar: {
            statusPanels: [
              {statusPanel: 'agTotalRowCountComponent', align: 'left'},
              {statusPanel: 'agFilteredRowCountComponent', align: 'left'},
              {statusPanel: 'agSelectedRowCountComponent'},
              {statusPanel: 'agAggregationComponent'},
            ],
          },
          overlayLoadingTemplate:
            '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
          onSelectionChanged: onSelectionChanged,
          onColumnRowGroupChanged: updateGridGroupPipeline,
          components: {
            statusCellRenderer: StatusCellRenderer,
            subStageCellRenderer: SubStageCellRenderer,
          },
          suppressCopyRowsToClipboard: true,
          enableRangeSelection: true,
          enableCharts: true,
          getContextMenuItems: getContextMenuItems,
        }

        // eslint-disable-next-line unicorn/consistent-function-scoping
        function StatusCellRenderer() {}
        StatusCellRenderer.prototype.init = parameter => {
          vm.eGui = document.createElement('div')
          const status = vm.applicationStatusList.find(
            status => status.name === parameter.value
          )
          vm.eGui.innerHTML =
            '<span class="round-circle" style="background:' +
            status.color +
            ';"> </span>' +
            '<span> ' +
            parameter.value +
            '</span>'
        }

        StatusCellRenderer.prototype.getGui = () => {
          return vm.eGui
        }

        // eslint-disable-next-line unicorn/consistent-function-scoping
        function SubStageCellRenderer() {}
        SubStageCellRenderer.prototype.init = parameter => {
          vm.eGui = document.createElement('div')
          const stage = vm.applicationSubStagesList.find(
            stage => stage.name === parameter.value
          )
          if (stage) {
            vm.eGui.innerHTML =
              '<span class="round-circle" style="background:' +
              stage.color +
              ';"> </span>' +
              '<span> ' +
              parameter.value +
              '</span>'
          }
        }

        SubStageCellRenderer.prototype.getGui = () => {
          return vm.eGui
        }

        const startSpinner = name => usSpinnerService.spin(name)
        const stopSpinner = name => usSpinnerService.stop(name)
        function cvCellClicked(parameter) {
          if (parameter.data.cvUrl)
            getApplicationResume(parameter.data.id, parameter.data.cvUrl)
        }

        vm.applicationsResume = []
        const getApplicationResume = async (applicationId, cvUrl) => {
          vm.showCv = {applicationId}
          vm.showCv.isDoc = false
          if (cvUrl.includes('.doc')) {
            vm.showCv.isDoc = true
          } else vm.splitGrid(true)

          const resumeFound = vm.applicationsResume.find(
            resume => resume.applicationId === applicationId
          )
          if (resumeFound) {
            vm.showCv.path = $sce.trustAsResourceUrl(resumeFound.url)

            if (vm.showCv.isDoc)
              vm.downloadDocFormatCV(cvUrl, vm.showCv.path, applicationId)
            else vm.showCv.display = vm.showCv.path
          } else {
            startSpinner('spinner-resume')
            const {
              status,
              data: resume,
            } = await ApplicationsApi.getApplicationResume(applicationId)
            if (status === 200) {
              if (resume.statusCode === 404) {
                if (cvUrl.includes('.doc')) vm.splitGrid(true)

                vm.showCv.isNotFound = true
              } else {
                const arrayBufferView = new Uint8Array(resume.data)
                const blob = vm.showCv.isDoc
                  ? new Blob([arrayBufferView], {
                      type: 'application/msword;base64',
                    })
                  : new Blob([arrayBufferView], {
                      type: 'application/pdf;base64',
                    })

                const urlCreator = $window.URL || $window.webkitURL
                const resumeUrl = urlCreator.createObjectURL(blob)
                vm.showCv.path = $sce.trustAsResourceUrl(resumeUrl)
                if (vm.showCv.isDoc)
                  vm.downloadDocFormatCV(cvUrl, vm.showCv.path, applicationId)
                else vm.showCv.display = vm.showCv.path

                vm.applicationsResume = [
                  ...vm.applicationsResume,
                  {
                    applicationId,
                    url: resumeUrl,
                  },
                ]
              }

              stopSpinner('spinner-resume')
            }
          }

          $scope.$applyAsync()
        }

        vm.downloadDocFormatCV = (cvUrl, path, applicationId) => {
          const format = cvUrl
            .split('.')
            .slice(1)
            .join('')

          let a = document.createElement('a')
          document.body.append(a)
          a.style = 'display: none'
          a.href = path
          a.download = `application-${applicationId}.${format}`
          a.click()
        }

        vm.splitGrid = value => {
          vm.showCv.isShow = value
          const agGridListingDiv = document.querySelector(`#${vm.gridName}`)
          const cvDiv = document.querySelector(`#myCV`)
          agGridListingDiv.style.height = window.innerHeight - 235 + 'px'
          agGridListingDiv.style.padding = 0
          cvDiv.style.height = window.innerHeight - 235 + 'px'
          if (value) {
            agGridListingDiv.style.width = '65%'
            agGridListingDiv.classList.add('col-md-7')
          } else agGridListingDiv.style.width = '100%'
        }

        async function onApplicationChange(parameter) {
          let fieldName = parameter.colDef.field
          const headerName = parameter.colDef.headerName
          if (parameter.newValue.trim() !== parameter.oldValue) {
            const applicationId = parameter.data.id
            await updateApplicationApi(
              headerName,
              applicationId,
              fieldName,
              parameter.newValue
            )
          }
        }

        const updateApplicationApi = async (
          headerName,
          id,
          fieldName,
          value
        ) => {
          try {
            const applicationExist = vm.deletedApplicationId
              ? isApplicationExist(vm.deletedApplicationId, vm)
              : true
            if (applicationExist) {
              const selectedRow = vm.gridOptions.api.getSelectedRows()

              let stageIdValue
              let stageIdName
              if (fieldName === 'applicationStage') {
                stageIdName = 'stageId'
                stageIdValue = vm.applicationSubStagesList.find(
                  ({name}) => name === value
                ).id
              }

              const payload = {
                [stageIdName ? stageIdName : fieldName]: stageIdValue
                  ? stageIdValue
                  : value,
              }

              const {
                data,
                status,
              } = await ApplicationsApi.updateApplicationById(id, payload)
              if (status === 200) {
                logger.notify(
                  'success',
                  `Application Id: ${id} ${headerName}: ${
                    value === null
                      ? ' deleted'
                      : 'value: "' + value + '" updated'
                  } successfully`
                )
                if (fieldName === 'applicationStage') {
                  selectedRow[0].lastStageChangeAt = data.lastStageChangeAt
                  selectedRow[0].stageId = data.stageId
                  const applicationStage = vm.applicationSubStagesList.find(
                    ({id}) => data.stageId === id
                  )
                  selectedRow[0].applicationStage = applicationStage.name
                  selectedRow[0].parentApplicationStage = vm.allApplicationStagesList.find(
                    ({id}) => applicationStage.parentId === id
                  ).name
                } else selectedRow[0][fieldName] = value

                vm.gridOptions.api.updateRowData({update: selectedRow})
                updateGridGroupPipeline()
              } else {
                logger.notify('error', 'Application Deleted by Other Admin')
              }
            }
          } catch (error) {
            logger.notify('error', error.data.message)
          }
        }

        function openHistoryModal(parameter) {
          const applicationHistoryModalInstance = $uibModal.open({
            templateUrl: 'application-history-modal.html',
            controller: 'ApplicationHistoryController',
            controllerAs: 'ctrl',
            windowClass: 'application-history-modal',
            backdrop: 'static',
            resolve: {
              isNote: function() {
                return parameter.colDef.field === 'note'
              },
              applicationId: function() {
                return parameter.data.id
              },
              agentsList: function() {
                return vm.agentsList
              },
              isOffPlatform: function() {
                return parameter.data.isOffPlatform
              },
              stagesList: function() {
                return vm.allApplicationStagesList
              },
              enableMasterGrid: function() {
                return false
              },
            },
          })
          applicationHistoryModalInstance.result.then(
            latestNote => {
              const selectedRow = [
                Object.assign(parameter.data, {note: latestNote}),
              ]
              vm.gridOptions.api.updateRowData({
                update: selectedRow,
              })
            },
            () => {}
          )
        }

        function openDateModal(parameter) {
          const fieldName = parameter.colDef.field
          const headerName = parameter.colDef.headerName
          vm.dateModal = {
            title: headerName,
            date: parameter.value ? new Date(parameter.value) : new Date(),
            isDate: fieldName.contains('interview'),
            isDelete: Boolean(parameter.value),
          }
          const modalInstance = $uibModal.open({
            templateUrl: 'date-modal.html',
            controller: 'DateModalController',
            controllerAs: 'ctrl',
            resolve: {
              selectedModal: function() {
                return vm.dateModal
              },
              id: function() {
                return parameter.data.id
              },
            },
          })
          modalInstance.result.then(
            async selectedDate => {
              await (selectedDate.isDeleted
                ? updateApplicationApi(
                    headerName,
                    parameter.data.id,
                    fieldName,
                    // eslint-disable-next-line unicorn/no-null
                    null
                  )
                : updateApplicationApi(
                    headerName,
                    parameter.data.id,
                    fieldName,
                    selectedDate.date
                  ))
            },
            () => {}
          )
        }

        function openAgentFollowersModal(parameter) {
          const headerName = parameter.colDef.headerName
          const applicationAgentModalInstance = $uibModal.open({
            templateUrl: 'application-agent-modal.html',
            controller: 'ApplicationAgentController',
            controllerAs: 'ctrl',
            resolve: {
              applicationId: function() {
                return parameter.data.id
              },
              consultant: function() {
                return {
                  employerAgentEmail: parameter.data.employerAgentEmail,
                  candidateAgentEmail: parameter.data.candidateAgentEmail,
                }
              },
              applicationAgent: function() {
                return parameter.value
              },
              agentsList: function() {
                return vm.agentsList
              },
            },
          })
          applicationAgentModalInstance.result.then(
            selectedAgent => {
              if (selectedAgent) {
                logger.notify(
                  'success',
                  `Application Id: ${parameter.data.id} ${headerName} updated successfully`
                )
                setApplicationAgentEmail(parameter.data, vm, selectedAgent)
                vm.gridOptions.api.updateRowData({update: [parameter.data]})
                updateGridGroupPipeline()
              }
            },
            () => {}
          )
        }

        function openCandidateProfileModal(parameter) {
          if (parameter.data.candidate) {
            vm.candidateProfile(parameter.data.candidate.id)
          }
        }

        vm.candidateProfile = code => {
          $uibModal.open({
            templateUrl: 'candidateProfileModal.html',
            windowClass: 'app-candidate-profile-modal-window',
            controller: 'CandidateProfileModalController',
            resolve: {
              data: function() {
                return code
              },
            },
          })
        }

        function openPositionDetailModal(parameter) {
          if (parameter.data.position) {
            positionDetailModal(
              parameter.data.position,
              parameter.data.employer
            )
          }
        }

        const positionDetailModal = (position, employer) => {
          position.employer = employer
          $uibModal.open({
            templateUrl: 'position-details-modal.html',
            windowClass: 'position-modal-window',
            controller: 'PositionDetailsController',
            controllerAs: 'ctrl',
            resolve: {
              position: function() {
                return position
              },
              listingName: function() {
                return vm.gridName
              },
            },
          })
        }

        function onSelectionChanged() {
          vm.selectedRows = vm.gridOptions.api.getSelectedRows()
          vm.selectedRowsLength = vm.selectedRows.length
          hideShowDropdownActionItem()
        }

        function onFilterChanged() {
          vm.filterCount = Object.keys(
            vm.gridOptions.api.getFilterModel()
          ).length
          let filterTextBoxValue = document.querySelector('#filter-text-box')
            .value
          if (filterTextBoxValue.length > 0) {
            vm.filterCount += 1
          }

          updatePipelineCountFromGrid()
        }

        // TODO: on grid functionality
        function updatePipelineCountFromGrid() {
          vm.gridOptions.api.forEachNode(node => {
            if (node.key) {
              vm.groupList.map(row => {
                if (row.id === node.id) {
                  row.applicationsCount = node.allChildrenCount
                  return row
                }

                return row
              })
            }
          })
          $scope.$applyAsync()
        }

        // TODO: on grid action items functionality
        function updateGridGroupPipeline() {
          vm.groupList = []

          vm.gridOptions.api.forEachNode(node => {
            if (node.key) {
              let hasChild = true
              if (
                _.isEmpty(node.childrenMapped) ||
                'undefined' in node.childrenMapped
              )
                hasChild = false
              vm.groupList.push({
                name: node.key,
                applicationsCount: node.allChildrenCount,
                color: node.leafGroup
                  ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16)
                  : lighten('#5e5e5e', (node.level + 1) * 10),
                id: node.id,
                intId: Number(node.id) * -1,
                level: node.level,
                parentID: node.parent.id,
                hasChild: hasChild,
                isHidden: node.level !== 0,
              })
            }
          })
          $log.debug('vm.groupList', vm.groupList)
          $scope.$applyAsync()
        }

        const hideShowDropdownActionItem = () => {
          vm.multiSelectOptions = undefined

          const functionName = vm.actionsFunctions[0].funcName
          const hideAccounts = vm.actionsFunctions[0].hideAccounts
          vm.actionsFunctions = [
            {
              funcName: functionName,
              leftClick: vm.hideAccounts,
              values: vm.applicationListing,
              hideAccounts: hideAccounts,
            },
          ]
          if (vm.selectedRowsLength > 0) {
            vm.multiSelectOptions = [
              {
                count: vm.selectedRowsLength,
              },
              {
                funcName: 'Clear Selection',
                function: vm.clearSelection,
              },
            ]
            const functionName = vm.actionsFunctions[0].funcName
            const hideAccounts = vm.actionsFunctions[0].hideAccounts
            vm.actionsFunctions = [
              {
                funcName: functionName,
                leftClick: vm.hideAccounts,
                values: vm.applicationListing,
                hideAccounts: hideAccounts,
              },
              {
                funcName: 'Mass Delete',
                leftClick: vm.deleteApplicationModal,
                visible: true,
                funcParameter: 'Application(s)',
                masterOnly: vm.isAllowedAgent(),
              },
            ]
            vm.gridDataActions = [
              {
                count: vm.selectedRowsLength,
              },
            ]
          }

          $scope.$applyAsync()
        }

        const dropdownApplicationStatus = async selectedStatus => {
          const selectedRows = vm.gridOptions.api.getSelectedRows()
          const selectedApplicationIds = selectedRows.map(x => x.id)
          const result = await updateBulkApplicationsApi(
            selectedApplicationIds,
            selectedStatus.name,
            'status'
          )

          if (result === 200) {
            selectedRows.map(row => {
              row.status = selectedStatus.name
              return row
            })
            vm.gridOptions.api.updateRowData({update: selectedRows})
            updateGridGroupPipeline()
            logger.notify(
              'success',
              `${selectedApplicationIds.length} Application${
                selectedApplicationIds.length > 1 ? 's ' : ' '
              }
              updated status to "${selectedStatus.name}"
              `
            )

            vm.gridOptions.api.deselectAll()
            $('#applicationStatusDropdownList').hide()
          }
        }

        const dropdownApplicationStage = async selectedStage => {
          const selectedRows = vm.gridOptions.api.getSelectedRows()
          const selectedApplicationIds = selectedRows.map(x => x.id)
          const result = await updateBulkApplicationsApi(
            selectedApplicationIds,
            selectedStage.id,
            'stageId'
          )

          if (result === 200) {
            const parentStage = vm.allApplicationStagesList.find(
              ({id}) => selectedStage.parentId === id
            ).name
            selectedRows.map(row => {
              row.applicationStage = selectedStage.name
              row.parentApplicationStage = parentStage
              return row
            })
            vm.gridOptions.api.updateRowData({update: selectedRows})
            updateGridGroupPipeline()
            logger.notify(
              'success',
              `${selectedApplicationIds.length} Application${
                selectedApplicationIds.length > 1 ? 's ' : ' '
              }
              updated stage to "${selectedStage.name}"`
            )
            vm.gridOptions.api.deselectAll()
            $('#applicationStageDropdownList').hide()
          }
        }

        const updateBulkApplicationsApi = async (
          applicationIds,
          selectedValue,
          column
        ) => {
          const payload = {applicationIds, [column]: selectedValue}
          try {
            const {status} = await ApplicationsApi.bulkApplicationUpdate(
              payload
            )
            if (status === 200) {
              return status
            }
          } catch (error) {
            logger.notify('error', error.data.message)
          }
        }

        vm.gridActionsDirective = {
          applicationStatus: {
            function: dropdownApplicationStatus,
            applicationStatusList: vm.applicationStatusList,
          },
        }

        vm.deleteApplicationModal = () => {
          const selectedRows = vm.gridOptions.api.getSelectedRows()
          const selectedApplicationIds = selectedRows.map(x => x.id)
          const deleteModalInstance = $uibModal.open({
            templateUrl: 'delete-application-modal.html',
            controller: 'DeleteApplicationController',
            controllerAs: 'ctrl',
            resolve: {
              type: function() {
                return 'Application(s)'
              },
              applicationIds: function() {
                return selectedApplicationIds
              },
            },
          })
          deleteModalInstance.result.then(
            () => {
              logger.notify(
                'success',
                `${selectedApplicationIds.length} Application${
                  selectedApplicationIds.length > 1 ? 's ' : ' '
                } Deleted Successfully!`
              )
              vm.gridOptions.api.updateRowData({remove: selectedRows})
              selectedRows.forEach(row => {
                vm.applicationListing.splice(
                  _.findIndex(vm.applicationListing, row),
                  1
                )
              })
              updateGridGroupPipeline()
            },
            () => {}
          )
        }

        function getContextMenuItems(parameter) {
          const result = [
            {
              name: 'Open profile in new tab ',
              action: function() {
                $window.open(
                  '/admin/lawyer-profile?user=' +
                    parameter.node.data.candidate.id,
                  '_blank'
                )
              },
            },
            {
              name: 'Expand All Columns',
              action: function() {
                const columnApi = gridOptions.columnApi.getColumnGroupState()
                columnApi.forEach(item => {
                  gridOptions.columnApi.setColumnGroupOpened(item.groupId, true)
                })
              },
            },
            {
              name: 'Collapse All Columns',
              action: function() {
                const columnApi = gridOptions.columnApi.getColumnGroupState()
                columnApi.forEach(item => {
                  gridOptions.columnApi.setColumnGroupOpened(
                    item.groupId,
                    false
                  )
                })
              },
            },
            'separator',
            'copy',
            'copyWithHeaders',
            'separator',
            'chartRange',
          ]
          vm.isExportAllowed = vm.user.roles.some(
            role => role.id === 'admin' || role.id === 'ops'
          )
          if (vm.isExportAllowed) result.push('export')
          return result
        }

        vm.hideAccounts = () => {
          let currentActiveFilters = vm.gridOptions.api.getFilterModel()
          if (vm.actionsFunctions[0].hideAccounts === true) {
            let hiddenData = vm.applicationListing.filter(
              application =>
                application.user.email &&
                application.user.email.toLowerCase().includes('@lexstep') ===
                  false &&
                application.user.email &&
                application.user.email.toLowerCase().includes('@emumba') ===
                  false
            )
            vm.gridOptions.api.setRowData(hiddenData)
          } else {
            vm.gridOptions.api.setRowData(vm.applicationListing)
          }

          vm.gridOptions.api.setFilterModel(currentActiveFilters)
          vm.actionsFunctions[0].hideAccounts = !vm.actionsFunctions[0]
            .hideAccounts
          if (vm.actionsFunctions[0].funcName === 'Hide Test Accounts')
            vm.actionsFunctions[0].funcName = 'Show Test Accounts'
          else vm.actionsFunctions[0].funcName = 'Hide Test Accounts'
          vm.gridOptions.api.deselectAll()
          onSelectionChanged()
          updateGridGroupPipeline()
        }

        vm.gridOptions = gridOptions

        vm.gridName = 'application'
        vm.filterCount = 0
        vm.helpTooltip = {
          name: 'Help',
          content: $sce.trustAsHtml(applicationHelpContent),
        }
        vm.actionsFunctions = [
          {
            funcName: 'Hide Test Accounts',
            leftClick: vm.hideAccounts,
            values: vm.applicationListing,
            hideAccounts: true,
          },
        ]

        vm.hideDropDown = () => {
          vm.showClass = ''
        }

        vm.showClass = ''
        vm.showDropDown = () => {
          if (vm.showClass === '') {
            vm.showClass = 'show'
          } else {
            vm.showClass = ''
          }
        }

        vm.isAllowedAgent = () => {
          return vm.user.roles.some(
            role => role.id === 'admin' || role.id === 'ops'
          )
        }

        vm.loadActiveApplicationsListing = applicationRecord => {
          vm.applicationListing = setApplicationsListingData(applicationRecord)
          vm.updateApplicationStageAction(vm.applicationStagesHierarchialList)
          vm.gridOptions.api.setRowData(vm.applicationListing)

          updateGridGroupPipeline()
          $scope.$apply()
        }

        vm.loadInactiveApplicationsListing = async () => {
          vm.inActiveApplications = []
          vm.formattedApplications = []

          const footer = document
            .querySelector(`#${vm.gridName}`)
            .querySelector(`.ag-status-bar-center`)
          footer.innerHTML = `<div style="text-align: center;align-self: center; display: flex;">
                              <div class="agGridLoader"></div>
                              <span style="padding-left: 15px">Loading In-Active Applications</span>
                            </div> `

          const [
            {data: acceptedApplication},
            {data: rejectedApplication},
            {data: declinedApplication},
            {data: withdrawnApplication},
          ] = await Promise.all([
            ApplicationsApi.getApplicationListing({
              status: applicationStatusEnum.ACCEPTED,
            }),
            ApplicationsApi.getApplicationListing({
              status: applicationStatusEnum.REJECTED,
            }),
            ApplicationsApi.getApplicationListing({
              status: applicationStatusEnum.DECLINED,
            }),
            ApplicationsApi.getApplicationListing({
              status: applicationStatusEnum.WITHDRAWN,
            }),
          ])

          vm.inActiveApplications = [
            ...vm.inActiveApplications,
            ...acceptedApplication,
            ...rejectedApplication,
            ...declinedApplication,
            ...withdrawnApplication,
          ]

          function formatInactiveApplicationsChunk(array, currentIndex) {
            if (currentIndex >= array.length) {
              vm.applicationListing = [
                ...vm.applicationListing,
                ...vm.formattedApplications,
              ]
              vm.gridOptions.api.updateRowData({
                add: vm.formattedApplications,
              })
              $rootScope.$broadcast('listing-loaded')

              footer.innerHTML = `<div style="text-align: center;align-self: center; display: flex;">
              <i class="fa fa-check" style="font-size:20px; color:green" aria-hidden="true"></i>
              <span style="padding-left: 15px" align-self: center;">Loaded In Active Application Successfully</span>
              </div>`
              const existingFilters = vm.gridOptions.api.getFilterModel()
              if (Object.keys(existingFilters).length === 0) {
                const filter = {
                  status: {values: ['Active'], filterType: 'set'},
                }
                vm.gridOptions.api.setFilterModel(filter)
              }

              updateGridGroupPipeline()
              $timeout(() => {
                footer.innerHTML = ''
              }, 1500)
              return
            }

            const formattedApplications = setApplicationsListingData(
              array[currentIndex]
            )

            vm.formattedApplications = [
              ...vm.formattedApplications,
              ...formattedApplications,
            ]

            ++currentIndex

            $timeout(() => {
              formatInactiveApplicationsChunk(array, currentIndex)
            }, 1)
          }

          formatInactiveApplicationsChunk(
            splitArrayIntoChunksOfLength(vm.inActiveApplications, 1000),
            0
          )
        }

        const setApplicationsListingData = applicationRecord => {
          return applicationRecord
            .map(data => {
              setEmployerColumnsData(data, vm)
              setCandidateColumnsData(data, vm)
              setCurrentExperienceColumnsData(data, vm)
              setPositionColumnData(data, vm, applicationRecord)
              data.applicationCandidateAgentEmail = data.userAgentId
                ? vm.agentsList.find(agent => agent.id === data.userAgentId)
                  ? vm.agentsList.find(agent => agent.id === data.userAgentId)
                      .email
                  : 'unassigned'
                : 'unassigned'

              data.applicationEmployerAgentEmail = data.employerAgentId
                ? vm.agentsList.find(agent => agent.id === data.employerAgentId)
                  ? vm.agentsList.find(
                      agent => agent.id === data.employerAgentId
                    ).email
                  : 'unassigned'
                : 'unassigned'
              setApplicationAgentEmail(data, vm)
              if (data.stageId) {
                const applicationStage = vm.applicationSubStagesList.find(
                  ({id}) => data.stageId === id
                )
                if (applicationStage) {
                  data.applicationStageOrder =
                    Boolean(applicationStage) && applicationStage.order

                  data.applicationStage = applicationStage.name
                  const parentApplicationStage = vm.allApplicationStagesList.find(
                    ({id}) => applicationStage.parentId === id
                  )

                  data.parentStageId = parentApplicationStage.id
                  data.parentStageOrder = parentApplicationStage.order
                  data.parentApplicationStage = parentApplicationStage.name
                  data.sponsorship = data.sponsorship ? 'Yes' : 'No'
                  data.isOffPlatform = data.isOffPlatform
                    ? 'Off-Platform'
                    : 'Platform'
                }
              }

              const applicationNote = vm.allApplicationsNotes.find(
                ({applicationId}) => data.id === applicationId
              )
              data.note = applicationNote ? applicationNote.body : ''
              return data
            })
            .sort((a, b) => (a.parentStageOrder > b.parentStageOrder ? 1 : -1))
            .sort((a, b) =>
              a.applicationStageOrder > b.applicationStageOrder ||
              a.parentStageOrder > b.parentStageOrder
                ? 1
                : -1
            )
        }

        vm.updateApplicationStageAction = (list, updateStageOnGrid) => {
          vm.gridOptions.columnDefs
            .find(column => column.headerName === 'Application Details')
            .children.find(
              column => column.field === 'applicationStage'
            ).cellEditorParams.values = vm.applicationSubStagesList.map(
            stage => stage.name
          )
          vm.gridActionsDirective.applicationStage = {
            function: dropdownApplicationStage,
            applicationStageList: list,
          }

          if (updateStageOnGrid) {
            // TODO: implement it later
          }
        }

        vm.applicationStagesHierarchialList = []
        const initializeApplicationListing = async () => {
          vm.innerHeight = $location.search().innerHeight
          vm.positionId = $location.search().positionId

          vm.user = await userService.getUser()

          const [
            {data: agentsList},
            {data: locationsList},
            {data: languagesList},
            {data: nationalitiesList},
            {data: schoolList},
            {data: legalPracticeAreaList},
            {data: legalEmployerTypeList},
            {data: legalJurisdictionList},
            {data: contractTypeList},
            {data: occupationList},
            {data: applicationStagesList},
            {data: applicationStagesHierarchialList},
            {data: activeApplicationListing},
            {data: applicationNoteResponse},
          ] = await Promise.all([
            CandidateProfileApi.getAdminAndCorporateUsers(),

            SharedApi.getAllLocations({
              regions: true,
            }),
            SharedApi.getAllLanguages(),
            SharedApi.getAllNationalities(),
            SharedApi.getAllSchools(),
            SharedApi.getCategoryById(1),
            SharedApi.getCategoryById(2),
            SharedApi.getCategoryById(3),
            SharedApi.getAllContractTypes(),
            SharedApi.getAllOccupations(),
            ApplicationStagesApi.getAllApplicationStages(),
            ApplicationStagesApi.getAllApplicationStages({hierarchy: true}),
            ApplicationsApi.getApplicationListing(
              vm.positionId
                ? {
                    positionId: Number(vm.positionId),
                  }
                : {status: applicationStatusEnum.ACTIVE}
            ),
            NotesApi.getAllNotes({
              type: 'application',
              order: 'DESC',
              includes: true,
            }),
          ])
          let uniqueApplicationsNotes = []
          applicationNoteResponse.forEach(note => {
            if (
              !uniqueApplicationsNotes.some(
                application => note.applicationId === application.applicationId
              )
            )
              uniqueApplicationsNotes.push(note)
          })
          vm.allApplicationsNotes = uniqueApplicationsNotes
          vm.agentsList = agentsList
          vm.legalPracticeAreaList = legalPracticeAreaList.specialties
          vm.legalEmployerTypeList = legalEmployerTypeList.specialties
          vm.jurisdictionList = legalJurisdictionList.specialties
          vm.locationsList = locationsList
          vm.languagesList = languagesList
          vm.nationalitiesList = nationalitiesList
          vm.schoolList = schoolList
          vm.contractTypesList = contractTypeList
          vm.occupationList = occupationList
          vm.applicationStagesHierarchialList = applicationStagesHierarchialList
          vm.applicationSubStagesList = applicationStagesList
            .filter(({parentId}) => parentId !== null)
            .sort((a, b) => Number(a.parentId) - Number(b.parentId))
          vm.allApplicationStagesList = applicationStagesList
          if (!vm.isAllowedAgent()) {
            vm.applicationSubStagesList = vm.applicationSubStagesList.filter(
              stage => stage.parentId !== 5
            )
            vm.applicationStagesHierarchialList = vm.applicationStagesHierarchialList.filter(
              stage => stage.id !== 5
            )
          }

          vm.loadActiveApplicationsListing(activeApplicationListing)
          if (!vm.positionId) vm.loadInactiveApplicationsListing()
        }
      },
    ])
})()

const isApplicationExist = (applicationId, vm) => {
  return vm.applicationListing.filter(({id}) => id === applicationId).length > 0
}

const addLight = (color, amount) => {
  let cc = Number.parseInt(color, 16) + amount
  let c = cc > 255 ? 255 : cc
  c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
  return c
}

const lighten = (color, amount) => {
  color = color.includes('#') ? color.slice(1, color.length) : color
  // eslint-disable-next-line radix
  amount = Number.parseInt((255 * amount) / 100)
  color = `#${addLight(color.slice(0, 2), amount)}${addLight(
    color.slice(2, 4),
    amount
  )}${addLight(color.slice(4, 6), amount)}`
  return color
}

function hexToRGB(h, opacity) {
  let r = 0
  let g = 0
  let b = 0

  // 3 digits
  if (h.length === 4) {
    r = '0x' + h[1] + h[1]
    g = '0x' + h[2] + h[2]
    b = '0x' + h[3] + h[3]

    // 6 digits
  } else if (h.length === 7) {
    r = '0x' + h[1] + h[2]
    g = '0x' + h[3] + h[4]
    b = '0x' + h[5] + h[6]
  }

  return `rgba(${Number(r)},${Number(g)},${Number(b)}, ${opacity})`
}

const setCandidateColumnsData = (data, vm) => {
  data.candidateAgentEmail = data.candidate.agentId
    ? vm.agentsList.find(agent => agent.id === data.candidate.agentId)
      ? vm.agentsList.find(agent => agent.id === data.candidate.agentId).email
      : 'unassigned'
    : 'unassigned'
  data.candidateFullName = `${data.user.firstName} ${data.user.lastName}`
  data.candidate.pqe = data.candidate.qualificationDate
    ? formatQualificationDateToPqe(data.candidate.qualificationDate)
    : ''
  data.candidate.location = data.candidate.location
    ? vm.locationsList.find(location => location.id === data.candidate.location)
        .name
    : ''
  data.candidate.languages =
    data.candidate.languages.length > 0
      ? vm.languagesList
          .filter(({code}) =>
            data.candidate.languages.find(language => language.code === code)
          )
          .map(language => language.name)
      : ''
  data.candidate.jurisdictions =
    data.candidate.jurisdictions.length > 0
      ? vm.jurisdictionList
          .filter(({id}) =>
            data.candidate.jurisdictions.find(
              jurisdiction => jurisdiction.id === id
            )
          )
          .map(jurisdiction => jurisdiction.name)
      : ''
  data.candidate.school = data.candidate.school
    ? vm.schoolList.find(school => school.id === data.candidate.school).name
    : ''
  data.candidate.nationality =
    data.candidate.nationalities && data.candidate.nationalities.length > 0
      ? vm.nationalitiesList
          .filter(({code}) =>
            data.candidate.nationalities.find(
              nationality => nationality.code === code
            )
          )
          .map(nationality => nationality.demonyms[0])
      : ''
  return data
}

const setPositionColumnData = (data, vm, applicationRecord) => {
  data.position.rPQE = `${
    data.position.lawPreferences.minPqe <= 0
      ? 'NQ'
      : data.position.lawPreferences.minPqe
  }${
    data.position.lawPreferences.maxPqe === 11
      ? '+'
      : data.position.lawPreferences.maxPqe <= 0 ||
        data.position.lawPreferences.maxPqe ===
          data.position.lawPreferences.minPqe
      ? ''
      : '-' + data.position.lawPreferences.maxPqe.toString()
  }`
  data.position.visible = data.position.visible ? 'Visible' : 'Invisible'

  data.position.specialties =
    data.position.specialties.length > 0
      ? vm.legalPracticeAreaList
          .filter(({id}) =>
            data.position.specialties.find(specialty => specialty.id === id)
          )
          .map(specialty => specialty.name)
      : ''

  data.position.locations =
    data.position.locations.length > 0
      ? vm.locationsList
          .filter(({id}) =>
            data.position.locations.find(location => location.id === id)
          )
          .map(location => location.name)
      : ''

  data.position.contractType =
    data.position.contractTypeId !== undefined ||
    data.position.contractTypeId !== null
      ? vm.contractTypesList.find(
          contract => contract.id === data.position.contractTypeId
        ).name
      : ''
  data.position.occupation = data.position.occupationId
    ? vm.occupationList.find(
        occupation => occupation.id === data.position.occupationId
      ).name
    : ''
  data.position.applicantCount = applicationRecord.filter(
    application => application.position.id === data.position.id
  ).length
  return data
}

const setEmployerColumnsData = (data, vm) => {
  let employerSelectivity = ''
  if (data.employer.selectivity) {
    for (let index = 1; index <= data.employer.selectivity; index++) {
      employerSelectivity += '$'
    }
  }

  if (data.employer.selectivity === 0) employerSelectivity = 'Uncategorized'
  data.employer.selectivity = employerSelectivity
  data.employer.type =
    data.employer.type.length > 0
      ? vm.legalEmployerTypeList
          .filter(({id}) =>
            data.employer.type.find(specialty => specialty.id === id)
          )
          .map(specialty => specialty.name)
          .join()
      : 'Auto-Generated'

  data.employerAgentEmail = data.employer.agentId
    ? vm.agentsList.find(agent => agent.id === data.employer.agentId)
      ? vm.agentsList.find(agent => agent.id === data.employer.agentId).email
      : 'unassigned'
    : 'unassigned'
  return data
}

const setCurrentExperienceColumnsData = (data, vm) => {
  data.currentExperience.contractType = data.currentExperience.contractTypeId
    ? vm.contractTypesList.find(
        contract => contract.id === data.currentExperience.contractTypeId
      ).name
    : ''
  data.currentExperience.occupation = data.currentExperience.occupationId
    ? vm.occupationList.find(
        occupation => occupation.id === data.currentExperience.occupationId
      ).name
    : ''
  data.currentExperience.specialties =
    data.currentExperience.positionSpecialties.length > 0
      ? vm.legalPracticeAreaList
          .filter(({id}) =>
            data.currentExperience.positionSpecialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
      : ''
  data.currentExperience.employerType =
    data.currentExperience.employerSpecialties.length > 0
      ? vm.legalEmployerTypeList
          .filter(({id}) =>
            data.currentExperience.employerSpecialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
          .join()
      : 'Auto-Generated'
  let currentEmployerSelectivity = ''
  if (
    data.currentExperience.employer &&
    data.currentExperience.employer.selectivity
  ) {
    for (
      let index = 1;
      index <= data.currentExperience.employer.selectivity;
      index++
    ) {
      currentEmployerSelectivity += '$'
    }
  }

  if (
    data.currentExperience.employer &&
    data.currentExperience.employer.selectivity === 0
  )
    currentEmployerSelectivity = 'Uncategorized'

  if (data.currentExperience.employer)
    data.currentExperience.employer.selectivity = currentEmployerSelectivity

  return data
}

const setApplicationAgentEmail = (data, vm, updatedAgent) => {
  if (updatedAgent) {
    if (updatedAgent.some(({id}) => id === 0)) data.applicationAgentEmail = []
    else data.applicationAgentEmail = updatedAgent.map(({email}) => email)
  } else {
    data.applicationAgentEmail =
      data.applicationAgents && data.applicationAgents.length > 0
        ? vm.agentsList
            .filter(({id}) =>
              data.applicationAgents.find(agent => agent.id === id)
            )
            .map(agent => agent.email)
        : []
  }

  return data
}

const applicationHelpContent = `<div>
  <p>	Applications displays indications of interest in positions and speculative opportunities made by (or on behalf of) LexStep candidates and allows you to update and track information relation to those applications.</p>
  <b>My Candidates and My Employers</b>
  <p>Filter by “My Candidates” and/or “My Employers” from the toolbar above the grid to see applications by candidates assigned to you and/or applications made to employers assigned to you.</p>
  <b>Filtering</b>
  <p>By default Applications filters archived applications and only shows those which have “Active” status.</p>
  <p>Further filters can be applied by hovering over each column header and selecting the hamburger menu on the right. When a filter is applied to a column a purple filter icon appears in the header beside the column name.</p>
  <b>Views</b>
  <p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the “Views” icon in the top right -- either as a Private “Saved View” or Shared with other team members.</p>
  <b>Clear</b>
  <p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data. The Clear filter icon also displays the number of filters currently active on the grid.</p>
  <b>Group</b>
  <p>The Applications grid is grouped by Stage, Sub-Stage, and Status by default. Drag and drop columns to the grouping drop zone in the grid’s top row to group rows by a particular column. You can Expand/Collapse All Rows from the Views icon in the top right to view positions by group.</p>
  <b>Sorting</b>
  <p>You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.</p>
  <b>Application Details</b>
  <p>Expanding the Application Details column group reveals information on each application.</p>
  <p>Internal Notes allow you to read and record comments on each application and view the history of any updates to that application.</p>
  <p>Admin Followers allows admin to receive alerts to any updates made to an application they are following. Admin Followers always includes the assigned Current Candidate Agent and Current Employer Agent (from that application’s Candidate Details and Target Employer Details column groups respectively) by default. You can choose to add or remove any other admin as an Admin Follower, which will include that admin on any email alerts.</p>
  <p></p>
  <p></p>
  <p>Application Candidate Agent and Application Employer Agent columns show the relevant assigned Candidate Agent and assigned Employer Agent at the time the application was made. In contrast to the Current Candidate Agent and Current Employer Agent columns, the data in these columns will not change if after an application is made the relevant candidate or employer is assigned a new admin.</p>
  <p>Feedback to Candidate (beta) allows admin to feed back to candidates in the form of leaving a text-string comment next to the relevant application on their Track page. (This feature is currently in beta and feedback is therefore only currently visible to admin).</p>
  <p>Stage enables admin to update and track the pipeline stage and sub-stage of an application. Current application Stages are:</p>
  <ul>
  <li>Applied</li>
  <li>Shortlisted</li>
  <li>Submitted</li>
  <li>Interview</li>
  </ul>
  <p>Status differentiates between active and archived applications. Status is independent of Stage and changing the status of an application at any Stage from Active to any of the other statuses will automatically archive the application whilst retaining the Stage, allowing you to track the Stage and Sub-Stage at which the application’s process was terminated. Archived statuses include:</p>
  <ul>
  <li>Rejected by LexStep - used prior to Submission if not Shortlisting an application and after Submission if there has been no response from an Employer after e.g. 1 month.</li>
  <li>Employer Declined - used when an Employer has directly fed back on the application</li>
  <li>Candidate Withdrew - used when a Candidate chooses to withdraw at any stage of the process</li>
  <li>Accepted - used when an offer is accepted.</li>
  </ul>
  <p>Source shows whether the candidate made the application themselves on Platform or whether the application was procured by a Candidate Agent Off-Platform and made on the candidate’s behalf.</p>
  <b>Actions</b>
  <p>Current Stage and Status of an application can be changed by selecting one or more applications and using the “Change Stage” or “Change Status” icons from the toolbar above the grid.</p>
  </div> `

const splitArrayIntoChunksOfLength = (array, length_) => {
  const chunks = []
  let index = 0
  const n = array.length
  while (index < n) {
    chunks.push(array.slice(index, (index += length_)))
  }

  return chunks
}



// WEBPACK FOOTER //
// ./scripts/admin-panel/application-listing/application-listing.ctrl.js